/**
 * KPI设置模块的常量定义
 */

// 部门-分类映射规则
export const DEPT_CATEGORY_RULES = [
    { keywords: ['财务'], categories: ['FINANCE', 'MANAGEMENT'] },
    { keywords: ['运营', '销售', '业务'], categories: ['OPERATION', 'MARKETING', 'MANAGEMENT'] },
    { keywords: ['物流', '仓储', '采购', '供应链'], categories: ['SUPPLY_CHAIN', 'MANAGEMENT'] },
    { keywords: ['开发', '研发', '技术', 'IT'], categories: ['PRODUCT', 'MANAGEMENT'] },
    { keywords: ['设计', '美工', '视觉'], categories: ['DESIGN', 'MANAGEMENT'] },
    { keywords: ['广告', '推广', '营销'], categories: ['MARKETING', 'OPERATION', 'MANAGEMENT'] },
    { keywords: ['客服', '售后'], categories: ['CUSTOMER_SERVICE', 'OPERATION', 'MANAGEMENT'] },
    { keywords: ['产品'], categories: ['PRODUCT', 'MANAGEMENT'] },
    { keywords: ['人事', '行政', '综合'], categories: ['MANAGEMENT'] },
];

// 类别映射
export const CATEGORY_MAP: Record<string, string> = {
    'FINANCE': '财务/业绩',
    'OPERATION': '运营/销售',
    'SUPPLY_CHAIN': '供应链/物流',
    'MARKETING': '市场/推广',
    'PRODUCT': '产品/研发',
    'DESIGN': '设计/视觉',
    'CUSTOMER_SERVICE': '客服/体验',
    'MANAGEMENT': '综合管理'
};

// 根据部门名称获取允许的分类
export function getAllowedCategories(deptName: string): string[] | null {
    for (const rule of DEPT_CATEGORY_RULES) {
        if (rule.keywords.some(k => deptName.includes(k))) {
            return rule.categories;
        }
    }
    return null;
}
